import Tooltip from 'tooltip.js';

export default function init () {
  const tooltipElements = Array.from(document.querySelectorAll('.tooltip-trigger'));

  tooltipElements.forEach((element) => {

    //trigger is click by default, but can be changed to hover with class below
    const toolTipTrigger = element.classList.contains('tooltip-trigger--hover') ? 'hover' : 'click';

    new Tooltip(element, {
      placement: 'top',
      trigger: toolTipTrigger,
      title: element.dataset.tooltip
    });
  });
}
